import React, {Component} from 'react';
import '../../styles/login.css';
import {LoginBody} from '../app/login/Login';
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux';
import {STATUS_SERVICE} from '../../constants/app/services';
import {Redirect} from 'react-router-dom';
import AuthAction from '../../redux/actions/auth';

class Login extends Component {
    state = {
        form: {
            documentType: '',
            username: '',
            password: '',
        },
        validationError: false,
        isRequired: {
            type: false,
            document: false,
            password: false
        }
    };
    verifyCaptcha = (captchaToken) => {
        if (captchaToken) this.handleSubmit(captchaToken);
    };
    handleChange = (property) => (e) => {
        this.props.loginReset();
        this.setState({form: {...this.state.form, [property]: e.target.value}});
    };
    handleSubmit = (captchaToken) => {
        const {form} = this.state;
        const {documentType, username, password} = form;
        if (captchaToken) {
            this.props.login(captchaToken, documentType, username, password);
        }
    };

    render() {
        const {form, validationError} = this.state;

        if ((this.props.status === STATUS_SERVICE.SUCCESS) && (this.props.token) && (this.props.loginSetOk)) {
            return <Redirect to='dashboard'/>;
        }
        return (
            <div className="Login">
                <LoginBody form={form} handleChange={this.handleChange} handleSubmit={this.handleSubmit}
                           isRequired={this.state.isRequired} status={this.props.status}
                           validationError={validationError} onVerifyCaptcha={this.verifyCaptcha}/>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        status: state.AuthReducer.statusLogin,
        token: state.AuthReducer.token,
        loginSetOk: state.AuthReducer.loginSetOk
    }
};
const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
    login: AuthAction.login,
    loginReset: AuthAction.loginReset
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/layouts/login.js